import axios from "axios"; // tslint:disable-line match-default-export-name

import { urls } from "@courses-pm2/api/src/ts/config";

type MediaLibraryItem = {
  Mp3Url?: string;
  Mp4Url?: string;
  OggUrl?: string;
  WebMUrl?: string;
};

type MediaLibraryResponse = MediaLibraryItem | MediaLibraryItem[] | undefined;

/**
 * resolve absolute url for media files stored in Gyldendals MediaLibrary
 */
export async function getUrlFromSrc(src: string): Promise<string | undefined> {
  if (src.includes("://")) {
    // return as is if we were already given an absolute URL
    return src;
  }

  const response = await axios.get<MediaLibraryResponse>(
    `${urls.mediaLibrary}/api/mediafiles/${src}`,
  );

  if (!response.data) {
    return;
  }

  if (Array.isArray(response.data)) {
    return response.data
      .map(getMp3Url)
      .find((it) => it !== undefined);
  } else {
    return getMp3Url(response.data);
  }
}

/**
 * extract mp3 url from media library item.
 */
function getMp3Url(item: MediaLibraryItem): string | undefined {
  return item.Mp3Url;
}
